import { defineComponent as _defineComponent } from 'vue'
import { InstagramPostItem } from '~/components/sections/SocialSection/SocialSectionInstagram/SocialSectionInstagram.vue';
import InstagramItem from './SocialSectionInstagramItem.vue';

interface Props {
  items?: InstagramPostItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialSectionInstagramGrid',
  props: {
    items: null
  },
  emits: ["item-click", "autoplay-toggle"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'item-click', index: number): void;
  (e: 'autoplay-toggle', index: number, value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items?: InstagramPostItem[];
};




const onItemClick = (index: number) => emit('item-click', index);

return { __sfc: true,props, emit, onItemClick, InstagramItem }
}

})